module.exports = __webpack_public_path__ + "static/img/MANCHESTER-OAK.7c2cc47.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/MANCHESTER-OAK.png
// module id = NZ9y
// module chunks = 0